import React from "react";
import { Link, useLocation } from "react-router-dom"; // or 'next/link' if you're using Next.js
import { appSettings } from "../../Router/constant";
import { isMobile } from "react-device-detect";
import { useSelector } from "react-redux";
import { SUBSCRIPTION_MODULE_TYPE, SUPPORTED_PAYMENT_METHOD, SUPPORTED_PAYMENT_METHOD_NAME } from "../../constants";
import ContentLoader from "react-content-loader";

const BreadcrumbsPayment = ({ selectedStep, mobileHeader, loader, handleStep }) => {
  const location = useLocation();
  const { paymentMethodSelection } = useSelector((state) => state.stripe);
  const { stripePlans } = useSelector((state) => state.stripe);

  // URL-to-display-name mapping
  // ${currencyWatchCrumbs ? currencyWatchCrumbs : ""} 
  const nameMap = {
    banktransfer: selectedStep === 1 ? (stripePlans?.planType?.value === SUBSCRIPTION_MODULE_TYPE.FUNDS || stripePlans?.planType?.value === SUBSCRIPTION_MODULE_TYPE.COMPANYFUNDS) ? "Add funds" : (stripePlans?.planType?.value === SUBSCRIPTION_MODULE_TYPE.CUSTOM || stripePlans?.planType?.value === SUBSCRIPTION_MODULE_TYPE.PAIDUPCAPITAL) ? "Select amount" : "Select quantity" : selectedStep === 2 ? "Select payment method" : paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER ||
      paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD
      ? SUPPORTED_PAYMENT_METHOD_NAME[paymentMethodSelection]
      : paymentMethodSelection ===
        SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
        ? `Crypto transfer`
        : "-",
    // Add more mappings as needed
  };

  const pathnames = location.pathname?.split(`/ `)?.filter((x) => x);
  const splitPatname = pathnames[0]?.split("/")?.filter((x) => x);

  // Check if it's the first page or root level
  const isFirstPage = splitPatname?.length <= 1;

  return (
    <nav aria-label="breadcrumb" className="">
      <ol className={`breadcrumb-custom ${isMobile ? "breadcrumb-custom-mobile breadcrumb-custom-payment" : ""} ${isFirstPage ? "breadcrumb-custom-mobile-first-page" : ""}`}>
        {isMobile && !isFirstPage ? (
          // Back button for mobile view (not shown on the first page)
          <li className="breadcrumb-item-custom">
            <button
              onClick={() => handleStep(1)} // Go back one step in history
              className="back-button-custom">
              <img src="assets/img/backIcon.svg" alt="" />
            </button>
            <p>{mobileHeader?.replace(/-/g, " ")}</p>
          </li>
        ) : (
          loader ?
            [1, 2, 3, 4].map((index) => (
              <li key={index} className="breadcrumb-item-custom">
                <ContentLoader width={80} height={20}>
                  <rect rx="5" ry="5" width={100} height={100} />
                </ContentLoader>
              </li>
            ))
            :
            // Full breadcrumbs for desktop view
            splitPatname.map((value, index) => {
              const to = `/${splitPatname?.slice(0, index + 1)?.join("/")}`;
              const isLast = index === splitPatname.length - 1;
              // Map value to a human-readable name or fallback to the URL part
              const displayName = nameMap[value] || value?.replace(/-/g, " ");
              return isLast ? (
                <li
                  key={to}
                  className="breadcrumb-item-custom active"
                  aria-current="page">
                  {displayName}
                </li>
              ) : (
                <li key={to} className="breadcrumb-item-custom">
                  <Link to={appSettings + to}>{displayName}</Link>
                  <img src="assets/img/breadcrumbIcon.svg" alt="" />
                </li>
              );
            })
        )}
      </ol>
    </nav>
  );
};

export default BreadcrumbsPayment;
